import { Button, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { proctorColumns } from './grid-columns';
import { useEffect, useState } from 'react';
import { SelectProctorResultDialog } from './select-proctor-result.dialog';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { proctorResultApiKeyStore } from '../../../../api/proctor-result-api-key-store';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { GuardedComponent } from '../../../../components/guarded-component';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { useSaveData } from '../../../../hooks/useSaveData';
import { State } from '@progress/kendo-data-query';
import { ProctorResult } from '../../../../models/proctor-result';
import useDebounce from '../../../../hooks/use-debounce';

const styling = {
  headingStyle: { fontWeight: 'bold' },
};

interface ProctorResultComponent {
  unitID: number;
  projectID: number;
}
export const ProctorResultComponent = ({ unitID, projectID }: ProctorResultComponent) => {
  const [unitProctor, setUnitProctor] = useState<any>();
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const { data, isLoading, isFetching } = useLoadData<ApiResponse<any>>(
    proctorResultApiKeyStore.getUnitProctorResults(unitID)
  );

  useEffect(() => {
    if (data) {
      setUnitProctor(data?.data);
    }
  }, [data]);

  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(
    gridApiKeyStore.getGridLayout('UnitEditProctorResult', 'UnitEditProctorResult')
  );

  // const { isLoading, data: Offices, refetch } = useLoadData<ApiResponse<Contact[]>>(getAPIKeyStore());

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredUnitEditProctorResults, setFilteredUnitEditProctorResults] = useState<ProctorResult[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredUnitEditProctorResultList = data?.data?.filter((unitEditProctor: any) =>
      Object.values(unitEditProctor).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredUnitEditProctorResults(filteredUnitEditProctorResultList || []);
  }, [debouncedSearchTerm, data?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'UnitEditProctorResult',
      pageName: 'UnitEditProctorResult',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'UnitEditProctorResult',
      pageName: 'UnitEditProctorResult',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);

  // ----------------------------------------------------------------------------------------

  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
            PROCTOR RESULTS
          </Typography>
        }
        action={
          <GuardedComponent requiredPermissions={[UserPermissionName.OVERRIDE]}>
            <Button className="btnLink" sx={{ p: 0, m: 0, mr: 1 }} variant="text" onClick={() => setOpenDialog(true)}>
              Map Proctor Results
            </Button>
          </GuardedComponent>
        }
      />
      <CardContent>
        <SiTrackGrid
          fileTitle='unit_proctor_result'
          dataItemKey="proctorResultsID"
          columns={proctorColumns}
          actionPermissions={{
            export: UserPermissionName.DOWNLOAD_GRID,
          }}
          isBusy={isLoading || isFetching || isLoadingGridLayout}
          // -----------------Grid Layout-------
          dataItems={filteredUnitEditProctorResults || []}
          reorderable
          // handleSearch={handleInputChange}
          handleSaveLayout={handleSaveLayout}
          isSaveLayout={true}
          gridConfigFromApi={gridConfig}
          handleResetLayout={handleResetLayout}
        // -----------------Grid Layout-------
        />
        {openDialog && (
          <SelectProctorResultDialog
            projectID={projectID}
            unitID={unitID}
            proctorResults={unitProctor ?? []}
            onClosed={() => setOpenDialog(false)}
          />
        )}
      </CardContent>
    </Card>
  );
};
